// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"_L-z","carouselContainer":"aM-z"};